import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import partnersData from "../../data/pages/partners.json";
import type { PartnersPageTemplate } from "../../types/partnersPageTemplate";
import { resolveCdnAssetUrl } from "../../utils/cdnAssetUrl";
import { HeroComponent } from "../../components/HeroComponent";
import { MdaiLink } from "../../components/MdaiLink";
import { PartnerCard } from "./PartnerCard";

const typedPartnersData = partnersData as PartnersPageTemplate;

const partners = typedPartnersData.partners.map((partner) => ({
  ...partner,
  imageSrc: resolveCdnAssetUrl(partner.imageSrc),
}));

const openSourceCommunityPartners = typedPartnersData.openSourcePartners.map(
  (partner) => ({
    ...partner,
    imageSrc: resolveCdnAssetUrl(partner.imageSrc),
  })
);

export default function Partners(): ReactElement {
  return (
    <Stack spacing={4} alignItems={"center"} pb={10}>
      <HeroComponent title={typedPartnersData.hero.title} titleVariant="h1" divider={false} />
      <Stack
        width={"100%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={4}
      >
        {partners.map((partner) => (
          <PartnerCard key={partner.name} {...partner} />
        ))}
      </Stack>

      <HeroComponent
        title={typedPartnersData.openSourceSection.title}
        titleVariant="h2"
        divider={false}
        description={
          <Stack
            direction={"column"}
            gap={2}
            alignItems={"center"}
            maxWidth={650}
            textAlign={"center"}
            mt={4}
          >
            <Typography>
              {typedPartnersData.openSourceSection.description}
            </Typography>
            <Typography sx={{ gap: "4px" }}>
              We invite you to join us in innovation at MyDecisive’s MDAI Labs
              on{" "}
              <MdaiLink
                label={typedPartnersData.openSourceSection.githubText}
                href={typedPartnersData.openSourceSection.githubHref}
                color="primary"
                style={{ gap: 0, display: "inline-flex" }}
              />
            </Typography>
          </Stack>
        }
      />
      <Stack
        width={"100%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={4}
      >
        {openSourceCommunityPartners.map((partner) => (
          <PartnerCard key={partner.name} {...partner} />
        ))}
      </Stack>
    </Stack>
  );
}
